import React, { useContext, useEffect, useState } from "react";
import { Container } from "@mui/material";
import { Text, TextInput, Button } from "@mantine/core";

import "./styles.scss";
import { useForm } from "@mantine/form";
import { DefaultErrorNotification, DefaultSuccessNotification, validateEmail, validatePhone } from "../../lib/Methods";
import { AppContext } from "../Dashboard";
import { Colors } from "../../lib/Data";
import { parseConfigFileTextToJson } from "typescript";
import { PerformRequest } from "../../lib/usePerformRequest";
import { Endpoints } from "../../lib/Endpoints";
import AnimateOnLoad from "../../components/AnimateOnLoad";

const Profile: React.FC = () => {
  const context = useContext(AppContext);
  const profileForm = useForm({
    initialValues: {
      name: "",
      email: "",
      phone: "",
    },
    validate: {
      name: (value) => (value && value.length > 3 ? null : "Enter your name"),
      phone: (value) => (validatePhone(value) ? null : "Enter a valid phone"),
      email: (value) => (validateEmail(value) ? null : "Enter a valid email"),
    },
  });

  useEffect(() => {
    if (context && context.profile && context.profile.id) {
      const { name, email, phone } = context.profile;
      profileForm.setValues({
        name,
        email,
        phone,
      });
    }
  }, [context]);

  const [isLoading, setLoading] = useState<boolean>(false);

  const UpdateProfile = async () => {
    const { hasErrors } = profileForm.validate();
    if (!hasErrors) {
      setLoading(true);
      const { email, name, phone } = profileForm.values;
      const r = await PerformRequest({
        method: "PATCH",
        route: Endpoints.GetAdminProfile(),
        data: { email, name, phone },
        callback: () => {
          setLoading(false);
        },
      });
      setLoading(false);
      if (r) {
        if (r.status === 409) {
          DefaultErrorNotification("Email or Phone already taken!");
        }
        if (r.status === 200) {
          DefaultSuccessNotification("Your profile has been updated!");
          context?.reloadProfile();
        }
      } else {
        DefaultErrorNotification("An error occurred!");
      }
    }
  };
  const inputProps = {
    mb: 15,
    disabled: isLoading,
  };
  return (
    <AnimateOnLoad>
      <Container maxWidth="lg">
        <div className="profile-container">
          <Text className="component-header">My Profile</Text>
          <br />
          <TextInput {...inputProps} label="Full Name" placeholder="Enter your name" {...profileForm.getInputProps("name")} />
          <TextInput {...inputProps} label="Email" placeholder="Enter your email address" {...profileForm.getInputProps("email")} />
          <TextInput {...inputProps} label="Phone number" placeholder="Enter your phone number" {...profileForm.getInputProps("phone")} />
          <div className="flex-row align-center justify-center">
            <Button w={200} onClick={UpdateProfile} mt={20} loading={isLoading} color={Colors.GreenPrimary} radius="50px">
              Update Profile
            </Button>
          </div>
        </div>
      </Container>
    </AnimateOnLoad>
  );
};

export default Profile;
